<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
   [spinner]="spinkit.skThreeBounce">
</ng-http-loader>



<div class="container">
   <div class="col-md-6 offset-md-6">
      <div class="row">
         <div class="col-md-6">
            <div class="table-row btn">
               <button tc-button [afterIcon]="'icofont-ui-add'" [square]="true" [tcShape]="500" [size]="'sm'"
                  (click)="addTable()" class="btn btn-primary"> Add Table</button>
            </div>
         </div>
         <div class="col-md-6">
            <tc-form-group class="table-row btn">
               <button class="button1" (click)=Onclickbutton()>
                  <tc-icon [iconClass]="'icofont-ui-home'" [tcFontSize]="22" [tcColor]="['#fffff', '#fffff']"
                     title="Back to Home" style="margin-top: -7px !important;"></tc-icon>
                  Back To Home
               </button>
            </tc-form-group>
         </div>
      </div>
   </div>



   <tc-card class="mb-0">
      <tc-table [rows]="tableDeatils" [search]="false" [hovered]="true" [pagination]="true" [headerBgColor]="'#fb8033'"
         [headerColor]="'#ffffff'" [headerBgColor]="'#3e51b5'">
         <tc-table-col [columnTitle]="'#'" [columnName]="'restaurant_serial_no'">
            <ng-template #tableTDTemplate let-value>
               <strong>{{ value }}</strong>
            </ng-template>
         </tc-table-col>
         <tc-table-col [columnTitle]="'Table Name'" [columnName]="'restaurant_table_name'">
            <ng-template #tableTDTemplate let-value>
               <strong>{{ value }}</strong>
            </ng-template>
         </tc-table-col>
         <tc-table-col class="nowrap" [columnTitle]="'Edit'" [columnName]="''">
            <ng-template #tableTDTemplate let-value="row">
               <ng-template [ngIf]="( value.restaurant_table_name === 'Web' )" 
                  [ngIfElse]="ngIfElseRef">
               </ng-template>
               <ng-template #ngIfElseRef let-condition>
                  <div class="actions nowrap">
                     <button tc-button [afterIcon]="'icofont-ui-edit'" [view]="'info'" [square]="true" [tcShape]="500"
                        [size]="'sm'"
                        (click)="openModals(modalBody, modalHeader,modalFooter,value.restaurant_table_id)"></button>
                  </div>
               </ng-template>
            </ng-template>
         </tc-table-col>
         <tc-table-col [columnTitle]="'Table Status'" [columnName]="'restaurant_table_status'">
            <ng-template #tableTDTemplate let-value="row">
               <ng-template [ngIf]="( value.restaurant_table_name === 'Web' )"
                  [ngIfElse]="ngIfElseRef"> </ng-template>
               <ng-template #ngIfElseRef let-condition>
                  <tc-switcher *ngIf="value.restaurant_table_status ==='Inactive'"
                     (click)="updateTableStatus(value.restaurant_table_id,'Active')" [value]="false"></tc-switcher>
                  <tc-switcher *ngIf="value.restaurant_table_status ==='Active'"
                     (click)="updateTableStatus(value.restaurant_table_id,'Inactive')" [value]="true"> </tc-switcher>
               </ng-template>
            </ng-template>
         </tc-table-col>
         <tc-table-col class="nowrap" [columnTitle]="'Download QR Code'" [columnName]="'restaurant_table_r_id'">
            
            <ng-template #tableTDTemplate let-value="row">

            <ng-template [ngIf]="( value.restaurant_table_name === 'Web' )"
                  [ngIfElse]="ngIfElseRef"> 
                  <button tc-button [afterIcon]="'icofont-download'" [square]="true" [tcShape]="500" [size]="'sm'"
                  [tcColor]="'#ffffff'" [tcBgColor]="'#262626'"
                  (click)="downLoadQrWeb()"></button>
               </ng-template>

               <ng-template #ngIfElseRef let-condition>
               
               <button tc-button [afterIcon]="'icofont-download'" [square]="true" [tcShape]="500" [size]="'sm'"
                  [tcColor]="'#ffffff'" [tcBgColor]="'#262626'"
                  (click)="downLoadQr(value.restaurant_table_id,value.restaurant_table_r_id)"></button>
            </ng-template>
         </ng-template>
         </tc-table-col>
         <tc-table-col class="nowrap" [columnTitle]="'Delete Tables'" [columnName]="'restaurant_table_status'">
            <ng-template #tableTDTemplate let-value="row">
               <ng-template [ngIf]="( value.restaurant_table_name === 'Web' )" 
                  [ngIfElse]="ngIfElseRef">
               </ng-template>
               <ng-template #ngIfElseRef let-condition>
                  <button tc-button [afterIcon]="'icofont-ui-delete'" [square]="true" [tcShape]="500" [size]="'sm'"
                     (click)="deleteTablepopup(value.restaurant_table_id)"></button>
               </ng-template>
            </ng-template>
         </tc-table-col>
      </tc-table>
   </tc-card>
   <div class="row" *ngIf="tableDeatils?.length === 0">
      <div class="col-12" align="center">
         <img src="./assets/img/no_table.png" alt="" style="width: 33%;">
      </div>
   </div>
</div>


<ng-container>
   <ng-template #modalHeader>
      <h2 class="title">Update Table Name</h2>
   </ng-template>
   <ng-template #modalBody>
      <form novalidate #heroForm="ngForm" class="new-patient-form">
         <div class="row">
            <div class="col-md-12">
               <tc-form-group>
                  <label for="restaurant_table_name" class="fnt-wght">Table Name</label>
                  <tc-input [placeholder]="'Table Name'" [(ngModel)]="restaurant_table_name"
                     [ngModelOptions]="{standalone: true}" required>
                  </tc-input>
               </tc-form-group>
            </div>
         </div>
      </form>
   </ng-template>
   <ng-template #modalFooter>
      <div class="actions">
         <button tc-button [type]="'button'" [view]="'error'" (click)="closeModal()"> Close</button>
         <button tc-button [view]="'info'" [disabled]="!restaurant_table_name"
            (click)="updateTableName(restaurant_table_id,restaurant_table_name)">
            Update
         </button>
      </div>
   </ng-template>
</ng-container>


